import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Integrated Township Living in Kalwa’s Prime Growth Corridor",
    "Spacious 1, 2 & 3 BHK Apartments by Birla Estates",
    "Gated 32-Acre Community with Multiple Residential Towers",
  ];
  const highlights2 = [
    "Lush Landscapes, Open Green Zones & Modern Recreational Spaces",
    "Excellent Connectivity to Thane, Airoli & Navi Mumbai",
    "Brought to You by the Reputed Birla Group Legacy",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Welcome to Birla Estates Kalwa, a visionary residential township in the
        heart of Kalwa-Airoli’s thriving development belt. Spread across 32
        acres, this gated enclave by Birla Estates is designed to offer a
        balanced lifestyle — blending nature, modern architecture, and everyday
        convenience.
        <br />
        Choose from thoughtfully crafted 1, 2 & 3 BHK homes surrounded by
        landscaped gardens, clubhouse facilities, and lifestyle amenities.
        Positioned strategically with excellent connectivity to Thane, Airoli,
        and Navi Mumbai, Birla Estates Kalwa is set to become a landmark
        residential address.
        <br />
        Crafted with precision and guided by the brand’s legacy, this project
        promises quality construction, intelligent space planning, and a
        future-ready living experience.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
